/* 周倉（關羽的扛刀將） */
import { SG, K, L, gd, landing } from '../../core/kit.ts';
import { defineHero, hook, U } from '../define.ts';

export default defineHero({
  id: 'zhoucang', name: '周倉', sub: '關羽的扛刀將', faction: 'shu', role: '坦克', weapon: 'guandao',
  look: { skin: '#5e3e2a', beard: 'bushy', eye: 'fierce', head: 'hood', bulk: 1.15, fx: '#72e3a3', c: { hood: '#26262c', armor: '#3a4a3a', pole: '#2a2a20' } },
  skills: [
    ['扛刀', 'charge', '扛刀衝撞，造成 {70/110/150/190} 傷害。'],
    ['擒將', 'hook', '抓住普攻射程內的一名隊友或敵人，往身後拋出。抓敵人：造成 {85/130/175/220} 傷害，摔落地再暈眩 1 秒；抓隊友：不受傷，拋回己方並獲得 {120/180/240/300} 護盾 3 秒（救人用）。', { sig: 'seize', aim: U(90), cd: 14 }],
    ['忠心', 'passive', '護甲 +{3/4/5/6}；關羽在場（存活）時再 +1。有隊友陣亡時攻擊 +{15/20/25/30}%，關羽陣亡時改為 +{30/35/40/45}%，持續到復活。', { pv: { armor: [3, 4, 5, 6] }, sig: 'loyal', atkAlly: [15, 20, 25, 30], atkGuan: [30, 35, 40, 45] }],
    ['翻江倒海', 'slam', '躍起重劈，範圍 {220/340/460} 傷害並擊飛。', { el: 'ice' }],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 忠心：關羽存活護甲 +1；有隊友陣亡攻擊 +15%，關羽陣亡 +30%（每 0.5 秒刷新光環時重算）
    hook('aura', 10, function () {
      for (const u of this.units) {
        if (!u.alive || u.kind !== 'hero' || !u.spec.skills) continue;
        const i = u.spec.skills.findIndex((s) => s.sig === 'loyal');
        if (i < 0 || !u.skillLv[i]) continue;
        const team = this.heroes(u.team), guan = team.find((h) => h.spec.id === 'guanyu');
        const sk = u.spec.skills[i], lv = u.skillLv[i];
        const atkP = guan && !guan.alive ? L(sk.atkGuan, lv) / 100 : team.some((h) => h !== u && !h.alive) ? L(sk.atkAlly, lv) / 100 : 0;
        this.addBuff(u, { id: 'loyal', t: 0.8, armor: guan && guan.alive ? 1 : 0, atkP });
      }
    }),
  ],
  methods: {
    // 周倉「擒將」：抓指定的隊友或敵人往身後拋。敵人受傷並暈眩；隊友不受傷、拋回己方並加護盾
    seize(u, a) {
      const p = a.pt, cand = this.units.filter((t) => t !== u && t.alive && !t.structure && t.kind !== 'boss' && t.kind !== 'cart' && t.kind !== 'ward' && !t.thrown && gd(p[0], p[1], t.x, t.y) < 90 + t.r && gd(u.x, u.y, t.x, t.y) <= u.range + t.r + 20 && (t.team === u.team ? t.kind === 'hero' : this.hostile(u, t)));
      cand.sort((x, y) => +(y.kind === 'hero') - +(x.kind === 'hero') || gd(p[0], p[1], x.x, x.y) - gd(p[0], p[1], y.x, y.y));
      const t = cand[0];
      if (!t) { this.fx({ k: 'puff', x: p[0], y: p[1] }); return; }
      const back = SG.dirTo(t, u.x, u.y); // 從目標指向周倉，繼續往周倉身後飛
      const fly = 160 / 560; // 拋出 160（從周倉身前 40 飛起，落在身後約 120；2026-10-02 使用者覺得原本的 280 太遠）
      const q = landing(u.x, u.y, u.x + a.dir[0] * 40, u.y + a.dir[1] * 40 * K);
      t.x = q[0]; t.y = q[1]; t.act = null;
      if (t.team === u.team) {
        t.thrown = { dir: back, time: fly, src: u, hit: {}, ally: true };
        const amt = SG.L([120, 180, 240, 300], a.lvl);
        t.st.shield = (t.st.shield || 0) + amt; t.st.shieldT = Math.max(t.st.shieldT, 3);
        this.fx({ k: 'heal', x: t.x, y: t.y, col: u.spec.fx });
        if (u.human || t.human) this.dmgEvents.push({ x: t.x, y: t.y - 30, text: '救！', team: t.team, src: u.id, tgt: t.id });
      } else {
        this.damage(u, t, a.dmg, { stagger: 0.3 });
        if (!t.alive) return;
        t.thrown = { dir: back, time: fly, src: u, hit: {}, stun: 1, land: a.dmg * 0.3 };
        t.st.stun = Math.max(t.st.stun, 0.9); t.anim = 'fall'; t.animSeq++;
        if (u.human || t.human) this.dmgEvents.push({ x: t.x, y: t.y - 20, text: '擒！', team: t.team, src: u.id, tgt: t.id });
      }
      u.f = Math.sign(back[0]) || u.f;
    },
  },
  // 專屬招式（技能資料裡的 sig，取代該原型的一般動作）：(u, a, k, dt, cross)，this 是 World
  sigSkills: {
    // 擒將
    seize(u, a, k, dt, cross) { if (cross(0.4)) this.seize(u, a); },
  },
});
